import { gql } from '@/__generated__/gql';

export const USER_QUERY = gql(`
  query ProfileUser($id: ID!) {
    user(id: $id) {
      id
      firstName
      lastName
      email
      officePhoneNumber {
        countryCode
        number
      }
      mobilePhoneNumber {
        countryCode
        number
      }
      lastLogin
      roles
      timezone
      emailNotifications
      title
      supervisorId
      supervisor {
        id
        firstName
        lastName
      }
    }
  }
`);

export const UPDATE_USER_PROFILE_MUTATION = gql(`
  mutation ProfileUpdateUserProfile($data: UpdateUserProfileInput!) {
    updateUserProfile(data: $data) {
      id
      firstName
      lastName
      emailNotifications
      timezone
      title
      officePhoneNumber {
        countryCode
        number
      }
    }
  }
`);

export const UPDATE_USER_MOBILE_PHONE_NUMBER_MUTATION = gql(`
  mutation ProfileUpdateUserMobile2FA($data: UserMobileNumberInput!) {
    updateUserMobile2FA(data: $data)
  }
`);
